export default __webpack_public_path__ + "static/ProValue_3@mob-808bece128f1fc44a9c6b3177bfdc6d9.webp";